const FETCH_DIRECTORS_N_SHAREHOLDERS_STARTED = "FETCH_DIRECTORS_N_SHAREHOLDERS_STARTED";
const FETCH_DIRECTORS_N_SHAREHOLDERS_SUCCEEDED = "FETCH_DIRECTORS_N_SHAREHOLDERS_SUCCEEDED";
const FETCH_DIRECTORS_N_SHAREHOLDERS_FAILED = "FETCH_DIRECTORS_N_SHAREHOLDERS_FAILED";

const UPDATE_DIRECTORS_N_SHAREHOLDERS_STARTED = "UPDATE_DIRECTORS_N_SHAREHOLDERS_STARTED";
const UPDATE_DIRECTORS_N_SHAREHOLDERS_SUCCEEDED = "UPDATE_DIRECTORS_N_SHAREHOLDERS_SUCCEEDED";
const UPDATE_DIRECTORS_N_SHAREHOLDERS_FAILED = "UPDATE_DIRECTORS_N_SHAREHOLDERS_FAILED";

const FETCH_DIRECTORS_CONSENT_STARTED = "FETCH_DIRECTORS_CONSENT_STARTED";
const FETCH_DIRECTORS_CONSENT_SUCCEEDED = "FETCH_DIRECTORS_CONSENT_SUCCEEDED";
const FETCH_DIRECTORS_CONSENT_FAILED = "FETCH_DIRECTORS_CONSENT_FAILED";

const RETRIEVE_OWNER_CONSENT_STARTED = "RETRIEVE_OWNER_CONSENT_STARTED";
const RETRIEVE_OWNER_CONSENT_SUCCEEDED = "RETRIEVE_OWNER_CONSENT_SUCCEEDED";
const RETRIEVE_OWNER_CONSENT_FAILED = "RETRIEVE_OWNER_CONSENT_FAILED";

export {
    FETCH_DIRECTORS_N_SHAREHOLDERS_STARTED,
    FETCH_DIRECTORS_N_SHAREHOLDERS_SUCCEEDED,
    FETCH_DIRECTORS_N_SHAREHOLDERS_FAILED,
    UPDATE_DIRECTORS_N_SHAREHOLDERS_STARTED,
    UPDATE_DIRECTORS_N_SHAREHOLDERS_SUCCEEDED,
    UPDATE_DIRECTORS_N_SHAREHOLDERS_FAILED,
    FETCH_DIRECTORS_CONSENT_STARTED,
    FETCH_DIRECTORS_CONSENT_SUCCEEDED,
    FETCH_DIRECTORS_CONSENT_FAILED,
    RETRIEVE_OWNER_CONSENT_STARTED,
    RETRIEVE_OWNER_CONSENT_SUCCEEDED,
    RETRIEVE_OWNER_CONSENT_FAILED,
};
